export default {
    state: {
    scheduleData: {},
    patientScheduleData: {},
    },
  
    getters: {
    getScheduleData(state){
        return state.scheduleData;
    },
    getPatientScheduleData(state){
        return state.patientScheduleData
    },

    },
    
  
    mutations: {
    setScheduleData(state, data){
      state.scheduleData = data
    },

    setPatientScheduleData(state, data){
        state.patientScheduleData = data
      }
    },
  
    actions: {
    changeScheduleData(context, infos){
      context.commit("setScheduleData", infos)
    },

    changePatientScheduleData(context, infos){
        context.commit("setPatientScheduleData", infos) 
    }
    }
  };
  